import React from 'react';
import { useHistory } from 'react-router-dom';
import { ReactComponent as RightArrow } from '../../../assets/icons/arrow.svg';
import AdminSubMenu from './AdminSubMenu.js';

function MobileSidebar({ userState, closeMenu, t }) {
  const history = useHistory();
  const role = userState.role?.toLowerCase();
  const roles = ['affidea', 'popupadmin'];

  console.log("userState", userState)
  const menuItems = [
    {
      label: t('userAccount.sidebar.visits'), // Vizitų istorija
      path: '/account/visits',
      subItems: [
        { label: 'Gydytojų konsultacijos', path: '/account/E025' },
        { label: 'Receptai', path: '/account/prescriptions' },
        { label: 'Siuntimai', path: '/account/referrals' },
        {
          label: 'Instrumentiniai tyrimai',
          path: '/account/instrumental-researches',
        },
        { label: 'Skiepai', path: '/account/vaccinations' },
        {
          label: 'Laboratoriniai tyrimai',
          path: '/account/labaratory-researches',
        },
        {
          label: 'Abonementai ir paslaugų paketai',
          path: '/account/complex-services',
        },
        {
          label: 'Patologiniai tyrimai',
          path: '/account/pathology-researches',
        },
        { label: 'Kitos paslaugos', path: '/account/other-visits' },
      ],
    },
    { label: 'Suplanuotos registracijos', path: '/account/registrations' },
    { label: 'Neįvykę vizitai', path: '/account/failed-registrations' },
    { label: 'Kuponai', path: '/account/user-coupons' },
    {
      label: 'Registracija',
      path: '/registration/local',
      subItems: [
        { label: 'Kreipimosi forma', path: '/registration/local' },
        { label: 'Kreipimųsi istorija', path: '/registration/local/list' },
      ],
    },
  ];

  const renderMenu = () => {
    return menuItems.map((item, index) => (
      <div key={index} className="mb-1">
        <div
          className="w-full flex justify-between items-center cursor-pointer hover:bg-blue-100 transition rounded px-2"
          onClick={() => {
            closeMenu();
            history.push(item.path);
          }}
        >
          <span className="option font-medium leading-tight py-1">
            {item.label}
          </span>
          <RightArrow />
        </div>

        {item.subItems &&
          item.subItems.map((sub, subIndex) => (
            <div
              key={subIndex}
              className="w-full flex items-center cursor-pointer hover:bg-blue-100 transition rounded ml-4 px-2"
              onClick={() => {
                closeMenu();
                history.push(sub.path);
              }}
            >
              <span className="option text-sm leading-tight py-1">
                {sub.label}
              </span>
            </div>
          ))}
      </div>
    ));
  };

  return (
    <div className="px-4 pt-2 pb-4">
      <div
        onClick={() => {
          history.push('/account');
          closeMenu();
        }}
      >
        {/* Title or logo placeholder */}
      </div>

      {renderMenu()}

      {roles.includes(role) && (
        <AdminSubMenu userState={userState} closeMenu={closeMenu} />
      )}
    </div>
  );
}

export default MobileSidebar;
